var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.3789 16 16 12.3789 16 8C16 3.61316 12.3789 0 7.99202 0C3.61316 0 0 3.61316 0 8C0 12.3789 3.62114 16 8 16ZM8 14.9631C4.13958 14.9631 1.03689 11.8524 1.03689 8C1.03689 4.13958 4.13958 1.02891 7.99202 1.02891C11.8524 1.02891 14.9631 4.13958 14.9711 8C14.9711 11.8524 11.8604 14.9631 8 14.9631ZM3.66102 8.78166H7.99202C8.24726 8.78166 8.43868 8.59023 8.43868 8.34297V2.75174C8.43868 2.50449 8.24726 2.32104 7.99202 2.32104C7.75274 2.32104 7.56132 2.50449 7.56132 2.75174V7.91226H3.66102C3.41376 7.91226 3.23031 8.10369 3.23031 8.34297C3.23031 8.59023 3.41376 8.78166 3.66102 8.78166Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/ClockIcon.455e47957f2d1d2635172ae47c02dadf.svg";
export { ForwardRef as ReactComponent };